import { render, staticRenderFns } from "./ContenuAdmin.vue?vue&type=template&id=3c6c61df&"
import script from "./ContenuAdmin.vue?vue&type=script&lang=js&"
export * from "./ContenuAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ContenuAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports